import { cn } from '@/utils/styles/cn'

export interface IRestaurantFlag {
    type?: string
    label: string
    style: { background: string; foreground: string }
}

/** Server-computed restaurant badge (NEW, top-10 rank, ...) in its payload colors */
export const RestaurantFlagBadge = ({
    flag,
    className,
}: {
    flag: IRestaurantFlag
    className?: string
}) => {
    return (
        <span
            className={cn(
                'rounded-full w-fit px-2.5 min-h-6 max-h-7 text-label-sm flex items-center whitespace-nowrap',
                className
            )}
            style={{
                backgroundColor: flag.style.background,
                color: flag.style.foreground,
            }}
        >
            {flag.label}
        </span>
    )
}
